import React from 'react';
import { Box } from '@mui/material';
import { SelectableButton } from './selectable-button';
import { AttendanceNotRelevantButton } from './attendance-not-relevant-button';
import { attendanceColumnMarginLeft, notRelevantColumnMarginLeft, notRelevantColumnMinWidth } from './attendance-column-layout';
import { AttendanceRegistrationTypeDto, AttendanceStateDto } from '../../../../../api-service/clients';
import { CitizenLessonAttendanceState } from '../interfaces';
import { selectableAttendanceStates } from '../utils';

interface IAttendanceProtocolActionBarProps {
  onAttendancesStartChange: (state: AttendanceStateDto) => void;
  onAttendancesEndChange: (state: AttendanceStateDto) => void;
  onNotRelevantsChange: () => void;
  showStartAttendanceRegistration: boolean;
  showEndAttendanceRegistration: boolean;
  citizenLessonAttendances: CitizenLessonAttendanceState[];
  isSaving?: boolean;
  isLocked?: boolean;
  isReadOnly?: boolean;
}

export function AttendanceProtocolActionBar(props: IAttendanceProtocolActionBarProps) {
  const {
    onAttendancesStartChange,
    onAttendancesEndChange,
    onNotRelevantsChange,
    showStartAttendanceRegistration,
    showEndAttendanceRegistration,
    citizenLessonAttendances,
    isSaving = false,
    isLocked = false,
    isReadOnly = false,
  } = props;

  const canRegister = !isLocked && !isSaving;
  const enableStart = canRegister && citizenLessonAttendances.some(x => x.requiresStartCheck && !x.startRegistration);
  const enableEnd = canRegister && citizenLessonAttendances.some(x => x.requiresEndCheck && !x.endRegistration);
  const enableNotRelevant = canRegister && citizenLessonAttendances.some(x => (x.requiresStartCheck || x.requiresEndCheck) && !x.startRegistration && !x.endRegistration);

  return (
    <Box display="flex" sx={{ paddingY: 2, fontSize: '1.4em' }} alignItems="center">
      <Box flex={1} minWidth={0} />
      {showStartAttendanceRegistration && (
        <Box display="flex" flexDirection="column" alignItems="center" marginLeft={attendanceColumnMarginLeft}>
          <Box sx={{ fontSize: '1rem', marginBottom: 0.5 }}>Fremmøde (start)</Box>
          <Box display="flex">
            {selectableAttendanceStates.map(attendanceState => (
              <SelectableButton
                key={attendanceState}
                disabled={!enableStart}
                readOnly={isReadOnly}
                isHeader
                registrationType={AttendanceRegistrationTypeDto.Start}
                attendanceState={attendanceState}
                onClick={() => onAttendancesStartChange(attendanceState)}
              />
            ))}
          </Box>
        </Box>
      )}
      {showEndAttendanceRegistration && (
        <Box display="flex" flexDirection="column" alignItems="center" marginLeft={attendanceColumnMarginLeft}>
          <Box sx={{ fontSize: '1rem', marginBottom: 0.5 }}>Fremmøde (slut)</Box>
          <Box display="flex">
            {selectableAttendanceStates.map(attendanceState => (
              <SelectableButton
                key={attendanceState}
                disabled={!enableEnd}
                readOnly={isReadOnly}
                isHeader
                registrationType={AttendanceRegistrationTypeDto.End}
                attendanceState={attendanceState}
                onClick={() => onAttendancesEndChange(attendanceState)}
              />
            ))}
          </Box>
        </Box>
      )}
      {(showStartAttendanceRegistration || showEndAttendanceRegistration) && (
        <Box display="flex" flexDirection="column" alignItems="center" marginLeft={notRelevantColumnMarginLeft} minWidth={notRelevantColumnMinWidth}>
          <Box sx={{ fontWeight: 'bold', fontSize: '1rem', marginBottom: 0.5 }}>Ikke relevant</Box>
          <Box display="flex">
            <AttendanceNotRelevantButton isHeader selected={false} disabled={!enableNotRelevant} readOnly={isReadOnly} onClick={onNotRelevantsChange} />
          </Box>
        </Box>
      )}
    </Box>
  );
}
